import React, { useState } from "react";
import Modal from "../../Modal/Modal";
import styles from "./ReportModal.module.scss";
import report_modal from "../../../images/Report_Modal.png";
import Button from "../Button/Button";
import toast from "../../Toast/toast";
import { API } from "../../../service/Interceptor";

const ReportModal = ({
  id,
  reportModal,
  setReportModal,
  type,
  coverImage = true,
  handleSubmit,
  setReport,
}) => {
  const [reportText, setReportText] = useState("");

  // ====================================================
  //                REPORTING PROJECT
  // ====================================================
  const handleReportProject = async () => {
    if (!reportText) {
      toast.error("Please Provide Reason");
      return;
    }
    const payload = {
      reason: reportText,
    };
    if (type === "Post") {
      try {
        const res = await API.post(`api/post/${id}/report`, payload);
        if (res.data.success) {
          setReportText("");
          setReportModal(false);
          toast.success("Post has been reported");
        }
      } catch (error) {
        console.log(error);
      }
    } else if (type === "Project") {
      try {
        const res = await API.post(`api/jobs/${id}/report`, payload);
        if (res.data.success) {
          setReportText("");
          setReportModal(false);
          toast.success("Project has been reported");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <Modal
      modalOpen={reportModal}
      onClose={() => {
        setReportModal(false);
        setReportText("");
      }}
    >
      <section className={styles.project_report_modal}>
        {/* LEFT DIV */}
        {coverImage && (
          <div className={styles.report_modal_left}>
            <img src={report_modal} alt="" />
          </div>
        )}
        {/* RIGHT DIV */}
        <div className={styles.report_modal_right}>
          <p className={styles.report_modal_title}>
            Report this {type?.toLowerCase()}
          </p>
          <p className={styles.report_modal_description}>
            Enter your reason to report this {type?.toLowerCase()}
          </p>
          <textarea
            value={reportText}
            onChange={(e) => {
              setReportText(e.target.value);
              setReport && setReport(e.target.value);
            }}
            draggable={false}
            rows={4}
            placeholder="Write the issue"
            className={styles.report_modal_textarea}
          />
          <div className={styles.report_modal_buttons}>
            <Button
              onClick={handleSubmit || handleReportProject}
              variant={"filled"}
            >
              <p className={styles.report_modal_submit}>Submit</p>
            </Button>
            <Button
              onClick={() => {
                setReportModal(false);
                setReportText("");
              }}
              variant={"outlined"}
            >
              Cancel
              {/* <p
                className={styles.report_modal_cancel}
                onClick={() => {
                  setReportText("");
                  setReport && setReport("");
                }}
              >
              </p> */}
            </Button>
          </div>
        </div>
      </section>
    </Modal>
  );
};

export default ReportModal;
